import { prepRoute } from "pages/basic";
export var basicRoute = prepRoute();
